<div class="timezone-picker-container">
  <app-pencil-searchable-dropdown
    [dataSource]="timezoneService.list$"
    [selectedItem]="resolvedTimezone"
    [placeholder]="placeholder | translate"
    [bindValue]="'value'"
    bindLabel="label"
    (selectedItemChanged)="onTimezoneSelected($event)"
  ></app-pencil-searchable-dropdown>
</div>
